import { render, staticRenderFns } from "./mcs-page-nav.vue?vue&type=template&id=56d02179&scoped=true&"
import script from "./mcs-page-nav.vue?vue&type=script&lang=js&"
export * from "./mcs-page-nav.vue?vue&type=script&lang=js&"
import style0 from "./mcs-page-nav.vue?vue&type=style&index=0&id=56d02179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d02179",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
